export const getYears = (date) => {
  const [cur_d, cur_m, cur_y] = new Date().toLocaleDateString().split(".");
  const [d, m, y] = date.split(".");
  let years = cur_y - y;
  if (cur_m - m < 0 || (cur_m - m === 0 && cur_d - d < 0)) {
    years--;
  }
  return years;
};
